// validators/password-strength.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface PasswordStrengthResult extends ValidationErrors {
  strength: number; // 0 a 5
}

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): PasswordStrengthResult | null => {
    const value = control.value || '';
    const errors: PasswordStrengthResult = { strength: 0 };

    if (value.length >= 6) errors.strength++;
    else errors.minLength = true;

    if (/[a-z]/.test(value)) errors.strength++;
    else errors.missingLowercase = true;

    if (/[A-Z]/.test(value)) errors.strength++;
    else errors.missingUppercase = true;

    if (/\d/.test(value)) errors.strength++;
    else errors.missingDigit = true;

    if (/[^\w\s]/.test(value)) errors.strength++;
    else errors.missingSpecial = true;

    return errors.strength === 5 ? null : errors;
  };
}
